// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d7f9c2a","238":"1faaaea8","242":"cfb7224d","453":"6ea9d2af","455":"46981c89","489":"b7c20c7b","557":"1914c845"}[chunkId] + ".chunk.js";
};